import {
    Dialog as RMWCDialog,
    DialogActions as RMWCDialogActions,
    DialogContent as RMWCDialogContent,
    DialogTitle as RMWCDialogTitle
} from "@rmwc/dialog";
import React, { FC, ReactNode } from "react";
import { Button, ButtonProps } from "react-toolbox/lib/button";

import "@material/button/dist/mdc.button.css";
import "@material/dialog/dist/mdc.dialog.css";
import "./style.nomodule.scss";
import style from "./style.scss";

interface DialogActionProps extends ButtonProps {}

interface DialogProps {
    actions?: DialogActionProps[];
    active: boolean;
    children?: ReactNode;
    contentOverflow?: "auto" | "clip" | "hidden" | "scroll" | "visible";
    title?: ReactNode;
    type?: "fullscreen" | "standard";
}

const Dialog: FC<DialogProps> = (props: DialogProps) => {
    const type = props.type || "standard";
    const contentStyle = { overflow: props.contentOverflow || "visible" };

    function triggerResize(state: "opening" | "opened" | "closing" | "closed") {
        if (state === "opened" && window && typeof window.dispatchEvent === "function") {
            window.dispatchEvent(new Event("resize"));
        }
    }

    return (
        <RMWCDialog open={props.active} className={style[type]} onStateChange={triggerResize}>
            <RMWCDialogTitle className={style.title}>{props.title}</RMWCDialogTitle>
            <RMWCDialogContent style={contentStyle}>{props.children}</RMWCDialogContent>
            <RMWCDialogActions>
                {
                    props.actions && props.actions.map((actionProps: DialogActionProps, i: number) => {
                        return <Button key={i} {...actionProps} />;
                    })
                }
            </RMWCDialogActions>
        </RMWCDialog>
    );
};

export { Dialog, DialogActionProps, DialogProps };
